// Users Page - Uses generic module initialization patterns
// Demonstrates the streamlined approach for creating module pages

import { createModulePage } from '../../components/generic/createModulePage';
import { initializeModule } from '../../utils/configInit';
import { usersConfig } from './usersConfig';
import { createUsersValidation } from './usersValidation';
// UsersService no longer needed - using SWR hooks directly

/**
 * Initialize the users module using generic utilities
 * This pattern eliminates the need for separate initialization files
 */
const { config: initializedConfig } = initializeModule(
  usersConfig,
  createUsersValidation
);

/**
 * Create the UsersPage using the generic module page factory
 * This eliminates the need for custom component wrappers
 */
const UsersPage = createModulePage(
  initializedConfig,
  {
    displayName: 'UsersPage',
    description: 'User Management System - Manage user accounts and access permissions'
  }
);

export default UsersPage;
